import * as faker from 'faker';
export const makeBucketList = (quantity) => Array(quantity).fill(0).map(() => makeBucket());
export const makeBucket = () => ({
    label: faker.commerce.productMaterial(),
    value: faker.commerce.productName(),
});
